import './../floatingtextcss.css';
import * as React from 'react';
import { FloatingTextViewImpl } from '../floatingtextview';
import { FloatingTextComponentProps, FloatingTextComponentState } from '../floatingtextcomponent';
import { MsisdnFloatingTextCSSStyle } from './msisdnfloatingtextcss';
import { Strings } from '../../../../utils/resources/strings';
import './msisdnfloattext-style.css';


export class MsisdnFloatingTextViewImpl extends FloatingTextViewImpl
{
    bindHandlers()
    {
        super.bindHandlers();
    }
    draw(props: FloatingTextComponentProps, state: FloatingTextComponentState, cssStyle: MsisdnFloatingTextCSSStyle): JSX.Element | boolean
    {    
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    <h1 className={state.class}>{props.placeholder}</h1>
                    <div style={{display: "flex", flexFlow: "row nowrap", textAlign: "left"}}>
                          {state.class !== ""  && <label style={cssStyle.getCountryCodeCSSStyle()}>{props.context.getResources().getString(Strings.countrycode) + " - "}</label>}
                        <input  onKeyDown={this.onKeyPress} disabled={props.isDisabled !== undefined ? props.isDisabled : false} value={state.value} type={props.inputType} onChange={this.onChange} style={state.errorMessage !== undefined ? cssStyle.getFloatingErrorTextCSSStyle(state.class === "" ? false : true) : cssStyle.getTextCSSStyle(state.class === "" ? false : true)} placeholder={props.hint}/>
                    </div>
                      <div style={{display:"flex"}}>
                        <div style={{width:"50%",textAlign:"left"}}>
                        <label id="msisdn-floating-example" style={cssStyle.getMSISDNTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{props.context.getResources().getString(Strings.msisdn_example)}</label> 
                        </div>

                      {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                            <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> 
                        </div>}
                      </div>
                      
                </div>
       );
    }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextview.tsx